module.exports = __webpack_public_path__ + "static/img/fast.6aec2b8.6aec2b89.png";